import React, { useEffect, useState } from "react"
import "./Inicio.css"
import { useNavigate } from "react-router-dom"
import { apiUrl } from "../../../global"
import { useForm } from "react-hook-form"
import Espanol from "../../../Components/Ingles/Espanol";
import Ingles from "../../../Components/Ingles/Ingles";
import tec from "./tec.png"
import FooterMovil from "../../../Components/FooterMovil/FooterMovil"

const Inicio = () => {
  //hooks
  const paisIdInicial = localStorage.getItem("paisID")
  const ciudadIdInicial = localStorage.getItem("ciudadID")
  const [paises, setPaises] = useState(null)
  const [ciudades, setCiudades] = useState(null)
  const [idPais, setIdPais] = useState(paisIdInicial)
  const [idCiudad, setIdCiudad] = useState(ciudadIdInicial)
  const [isEnglish, setisEnglish] = useState(0);// ESTE VARIABLE SE REFIERE AL IDIOMA 

  const {
    handleSubmit
  } = useForm()
  let navigate = useNavigate()
  const selectCiudad = (e) => {
    setIdCiudad(e.target.value)
  }
  const selectPais = (e) => {
    setIdPais(e.target.value)
  }
  const onSubmitR = async () => {
    localStorage.setItem("paisID", idPais)
    localStorage.setItem("ciudadID", idCiudad)
    console.log("pais: ", idPais, " ciudad: ", idCiudad)
    navigate("../rubro")
  }

  useEffect(() => {
    if (localStorage.getItem("ingles") == null) {
      localStorage.setItem("ingles", 0) // si no hay una opción seleccionada lo pongo en español
    }
    setisEnglish(localStorage.getItem("ingles"))

    //sacamos los paises
    fetch(apiUrl + "obtenerCiudades.php")
      .then((respone) => {
        if (!respone.ok) {
          throw new Error("Error en fetch al cargar los paises")
        }
        return respone.json()
      })
      .then((json) => {
        setPaises(json.data) // guardamos en el hook de paises los datos
      })
    fetch(apiUrl + "obtenerCiudades.php?mx=1")
      .then((resp) => {
        if (!resp.ok) {
          throw new Error("Error en fetch al cargar las ciudades")
        }
        return resp.json()
      })
      .then((json) => {
        setCiudades(json.data)
      })
    console.log(localStorage.getItem("paisID"))
    console.log(localStorage.getItem("ciudadID"))
    setIdPais(localStorage.getItem("paisID"))
    setIdCiudad(localStorage.getItem("ciudadID"))
  }, [])

  // eslint-disable-next-line eqeqeq
  if (isEnglish == 0) return (
    <>
      <Espanol handleEvent={setisEnglish} />
      <div className="ini">
        <img className="logotec" src={tec} alt="Tec logo" />
        <div id="divBloqueConInfoInicio" className="px-10 ms-xl-4" >
          <div className="infoini">
            <h1 className="tituloini">COSTO DE VIDA</h1>
            <p className="pregunini">¿Quieres conocer más a detalle las costos en las ciudades principales de México?</p>
            <br />
            <p className="inpini">
              Te invitamos a utilizar nuestro simulador para que puedas planificar tus gastos de la mejor manera.
              Puedes comparar los costos respecto a tu país de origen en los rubros de alimentación, transporte,
              alquiler, servicios médicos y entretenimiento.
            </p>
          </div>
        </div>
        <form className="barracom" onSubmit={handleSubmit(onSubmitR)}>
          <div className="botonini btn-group">
            <select
              type="button"
              name="pais"
              className="botonsel btn dropdown-toggle"
              data-bs-toggle="dropdown"
              aria-expanded="false"
              onChange={selectPais}
              value={idPais}
            >
              <option defaultValue="0" disabled selected>
                Seleccionar país
              </option>
              {paises &&
                paises.map((pais) => {
                  const id = pais.id
                  const name = pais.ciudad
                  return (
                    <option key={id} value={id}>
                      {name}
                    </option>
                  )
                })}
            </select>
          </div>
          <div className="botonini btn-group">
            <select
              type="button"
              name="campus"
              className="botonsel btn dropdown-toggle"
              data-bs-toggle="dropdown"
              aria-expanded="false"
              onChange={selectCiudad}
              value={idCiudad}
            >
              <option defaultValue="0" disabled selected>
                Seleccionar ciudad
              </option>
              {ciudades &&
                ciudades.map(({ id, ciudad }) => (
                  <option key={id} value={id}>
                    {ciudad}
                  </option>
                ))}
            </select>
          </div>
          <button className={!idCiudad || !idPais ? 'disabled-btnini' : 'btnini'} type="submit" disabled={!idCiudad || !idPais}>
            Comparar
          </button>
        </form>
        <FooterMovil />
      </div>

    </>
  )
  else return (
    <>
      <Ingles handleEvent={setisEnglish} />
      <div className="ini">
      <img className="logotec" src={tec} alt="Tec logo" />
        <div id="divBloqueConInfoInicio" className="px-10 ms-xl-4" >
          <div className="infoini">
            <h1 className="tituloini">COST OF LIVING</h1>
            <p className="pregunini">Want to learn more about the cost of living in the main cities of our international campuses?</p>
            <br />
            <p className="inpini">
              "Use our calculator to help plan your expenses. You can compare costs with your home country in areas
              such as Food, Transportation, Rent, Medical Services and Entertainment."
            </p>
          </div>
        </div>
        <form className="barracom" onSubmit={handleSubmit(onSubmitR)}>
          <div className="botonini btn-group">
            <select
              type="button"
              name="pais"
              className="botonsel btn dropdown-toggle"
              data-bs-toggle="dropdown"
              aria-expanded="false"
              onChange={selectPais}
              value={idPais}
            >
              <option value="0" disabled selected>
                Select country
              </option>
              {paises &&
                paises.map((pais) => {
                  const id = pais.id
                  const name = pais.ciudad_e
                  return (
                    <option key={id} value={id}>
                      {name}
                    </option>
                  )
                })}
            </select>
          </div>
          <div className="botonini btn-group">
            <select
              type="button"
              name="campus"
              className="botonsel btn dropdown-toggle"
              data-bs-toggle="dropdown"
              aria-expanded="false"
              onChange={selectCiudad}
              value={idCiudad}
            >
              <option value="0" disabled selected>
                Select city
              </option>
              {ciudades &&
                ciudades.map(({ id, ciudad_e }) => (
                  <option key={id} value={id}>
                    {ciudad_e}
                  </option>
                ))}
            </select>
          </div>
          <button className={!idCiudad || !idPais ? 'disabled-btnini' : 'btnini'} type="submit" disabled={!idCiudad || !idPais}>
            Compare
          </button>
        </form>
        <FooterMovil />
      </div>

    </>
  )
}

export default Inicio
